export default __webpack_public_path__ + "static/media/poster5.48dfc8f6.png";